import { useEffect, useId, useState } from 'react'
import { Dialog } from './Dialog.jsx'

/** Rename a conversation or project; used by the chat header menu and the sidebars. */
export function RenameDialog({ open, initialTitle, onClose, onSave, title = 'Rename conversation' }) {
  const [value, setValue] = useState(initialTitle)
  const formId = useId()
  useEffect(() => {
    if (open) setValue(initialTitle)
  }, [open, initialTitle])
  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={title}
      footer={
        <>
          <button type="button" className="btn btn-ghost" onClick={onClose}>
            Cancel
          </button>
          <button type="submit" form={formId} className="btn btn-dark" disabled={!value.trim()}>
            Save
          </button>
        </>
      }
    >
      <form
        id={formId}
        onSubmit={(event) => {
          event.preventDefault()
          onSave(value.trim())
        }}
      >
        <label className="field">
          <span>Title</span>
          <input autoFocus value={value} maxLength={120} onChange={(e) => setValue(e.target.value)} />
        </label>
      </form>
    </Dialog>
  )
}
